var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g3, _g4, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _g5, _g6, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _g7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgGlossaryEquipment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "70%",
    height: "auto",
    viewBox: "0 0 296.176 262.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_7782",
    "data-name": "Group 7782",
    transform: "translate(-5687 -6126.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img-glossary-equipment",
    transform: "translate(5752 6133.25)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13445",
    "data-name": "Path 13445",
    d: "M365.54,261.035l-.406,26.276-1.954-1.125.406-26.276Z",
    transform: "translate(-313.828 -110.211)",
    fill: "#e8e8e8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13446",
    "data-name": "Path 13446",
    d: "M365.794,259.122l5.242-3.048-1.954-1.125L363.84,258Z",
    transform: "translate(-314.083 -108.164)",
    fill: "#f4f4f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13447",
    "data-name": "Path 13447",
    d: "M457.678,118.858l-.246,133.524L421.54,231.661l.24-130.611Z",
    transform: "translate(-336.326 -48.72)",
    fill: "#e8e8e8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13448",
    "data-name": "Path 13448",
    d: "M421.93,100.244l35.9,18.017-4.787,2.778,1.948,1.131,7.835-4L423.884,98.96Z",
    transform: "translate(-336.477 -47.368)",
    fill: "#f4f4f4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13449",
    "data-name": "Path 13449",
    d: "M399.409,152.21l-.24,99.174L363.51,272.1l.24-99.174Z",
    transform: "translate(-313.956 -68.641)",
    fill: "#c7c8ca"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13450",
    "data-name": "Path 13450",
    d: "M394.84,179.61v57.375l-30.62,17.568.1-57.2Z",
    transform: "translate(-314.229 -79.08)",
    fill: "#0075bf"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13451",
    "data-name": "Path 13451",
    d: "M414.05,179.61l30.608,17.673-.43,57.388L414.05,236.985Z",
    transform: "translate(-333.439 -79.081)",
    fill: "#169fdb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13452",
    "data-name": "Path 13452",
    d: "M364.22,290.548l30.62-17.568,30.51,17.507-30.522,17.734Z",
    transform: "translate(-314.229 -115.36)",
    fill: "#58ab27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13453",
    "data-name": "Path 13453",
    d: "M422.35,198.95l19.344,11.172-.061,34.369L422.35,233.423Z",
    transform: "translate(-336.639 -86.492)",
    fill: "#86c2eb"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "translate(80.593 118.161)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13454",
    "data-name": "Path 13454",
    d: "M414.038,226.141l30.608-17.771-.43,34.737-30.2,17.544Z",
    transform: "translate(-414.02 -208.37)",
    fill: "#0075bf"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(67.965 109.739)",
    style: {
      isolation: "isolate"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13455",
    "data-name": "Path 13455",
    d: "M406.467,213.988l-.037,1.284-12.96-7.478.043-1.284Z",
    transform: "translate(-393.47 -199.001)",
    fill: "#f4f4f4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13456",
    "data-name": "Path 13456",
    d: "M414.6,213.969l12.923-7.509-.043,1.284-12.917,7.509Z",
    transform: "translate(-401.6 -198.982)",
    fill: "#c7c8ca"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13457",
    "data-name": "Path 13457",
    d: "M393.54,201.8l12.917-7.509,12.96,7.478-12.923,7.509Z",
    transform: "translate(-393.497 -194.29)",
    fill: "#f4f4f4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "translate(50.071 100.694)",
    opacity: 0.52
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13458",
    "data-name": "Path 13458",
    d: "M364.35,197.3l30.522-17.734,30.626,17.7L394.89,215.039Z",
    transform: "translate(-364.35 -179.57)",
    fill: "#c9e1f6"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13459",
    "data-name": "Path 13459",
    d: "M362.19,267.421l.8-.461,15.786,9.113-.8.461Z",
    transform: "translate(-313.447 -112.872)",
    fill: "#86c2eb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13460",
    "data-name": "Path 13460",
    d: "M387.787,282.251l-.147,51.372h.184l.615-.356.148-51.476Z",
    transform: "translate(-323.258 -119.225)",
    fill: "#0075bf"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13461",
    "data-name": "Path 13461",
    d: "M387.713,333.846h-.363l.141-51.476h.369Z",
    transform: "translate(-323.146 -119.448)",
    fill: "#86c2eb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13462",
    "data-name": "Path 13462",
    d: "M414.137,297.477l.793-.467-.147,51.482-.793.461Z",
    transform: "translate(-333.416 -125.092)",
    fill: "#0075bf"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13463",
    "data-name": "Path 13463",
    d: "M389.088,281.97l-.608.35v.221l15.823,9.138.793-.467Z",
    transform: "translate(-323.582 -118.727)",
    fill: "#86c2eb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13464",
    "data-name": "Path 13464",
    d: "M365.423,174.462l-3.964-2.286,35.659-20.721-.012-2.255L357.57,172.176l5.911,3.41Z",
    transform: "translate(-311.666 -66.987)",
    fill: "#f4f4f4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13465",
    "data-name": "Path 13465",
    d: "M395.424,125.308v62.175L364.14,169.33l.1-62.23Z",
    transform: "translate(-314.198 -50.695)",
    fill: "#e51a92",
    opacity: 0.2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(81.207 52.186)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13466",
    "data-name": "Path 13466",
    d: "M415.038,122.732,455.38,100.42l-.436,96.083L415.02,218.588Z",
    transform: "translate(-415.02 -100.42)",
    fill: "#e51a92"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(50.04 33.576)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13467",
    "data-name": "Path 13467",
    d: "M364.3,92.4,402.767,68.98l33.06,19.32-40.342,22.312Z",
    transform: "translate(-364.3 -68.98)",
    fill: "#e51a92"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13468",
    "data-name": "Path 13468",
    d: "M469.7,134.528l-.479.952L467.6,241.917l-5.832,4.338,1,26.688,15.418-8.554V130.22Z",
    transform: "translate(-351.835 -60.794)",
    fill: "#c7c8ca"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13469",
    "data-name": "Path 13469",
    d: "M462.57,317.455l-.406,27.234-1.954-1.131.406-27.228Z",
    transform: "translate(-351.234 -132.54)",
    fill: "#e8e8e8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13470",
    "data-name": "Path 13470",
    d: "M462.824,315.542l5.242-3.042-1.954-1.131-5.242,3.048Z",
    transform: "translate(-351.488 -130.164)",
    fill: "#f4f4f4"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13471",
    "data-name": "Path 13471",
    d: "M473.29,135.915l-1.936,108.514L469.4,243.3l1.942-108.508Z",
    transform: "translate(-354.777 -61.707)",
    fill: "#f4f4f4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13472",
    "data-name": "Path 13472",
    d: "M371.9,310.57l-.406,26.276-2.181,1.376.651-26.528,1.936-1.125",
    transform: "translate(-316.191 -129.99)",
    fill: "#c7c8ca"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13473",
    "data-name": "Path 13473",
    d: "M366.4,263.648,364.2,190.5l-6.784-3.914-.24,98.768,8.363,4.83Z",
    transform: "translate(-311.515 -82.023)",
    fill: "#e8e8e8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13474",
    "data-name": "Path 13474",
    d: "M369.132,190.31l1.948,73.9-1.936,1.125-1.954-73.9Z",
    transform: "translate(-315.374 -83.272)",
    fill: "#c7c8ca"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13475",
    "data-name": "Path 13475",
    d: "M377.74,328.195l.147-51.372L362.1,267.71l-.141,51.476,15.6,9.009Z",
    transform: "translate(-313.358 -113.797)",
    fill: "#5aaadc"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13476",
    "data-name": "Path 13476",
    d: "M378.084,304.69l.08-27.738L362.15,267.71l-.08,27.738Z",
    transform: "translate(-313.4 -113.312)",
    fill: "#86c2eb"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13477",
    "data-name": "Path 13477",
    d: "M388.48,282.9v51.562l15.676,9.052.147-51.476Z",
    transform: "translate(-323.582 -119.653)",
    fill: "#5aaadc"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13478",
    "data-name": "Path 13478",
    d: "M404.223,319.77l.08-27.732L388.48,282.9v27.781Z",
    transform: "translate(-323.582 -119.245)",
    fill: "#86c2eb"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13479",
    "data-name": "Path 13479",
    d: "M283.379,116.6v-9.1a.19.19,0,0,1,.055-.16.221.221,0,0,1,.154-.043h.842a.252.252,0,0,1,.141.043.178.178,0,0,1,.061.16v8.216h3.429a.147.147,0,0,1,.111.037.2.2,0,0,1,.037.141v.768a.147.147,0,0,1-.037.117.184.184,0,0,1-.111,0h-4.467a.221.221,0,0,1-.154-.049.185.185,0,0,1-.061-.129Z",
    transform: "translate(-283.064 -50.597)",
    fill: "#edeff0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13480",
    "data-name": "Path 13480",
    d: "M294.805,107.977a.185.185,0,0,1-.043.135.2.2,0,0,1-.1,0h-1.229a.215.215,0,0,1-.123,0,.184.184,0,0,1-.037-.135V106.9a.178.178,0,0,1,.037-.135.209.209,0,0,1,.123-.031h1.229a.209.209,0,0,1,.1.031.178.178,0,0,1,.043.135Zm-.166,1.653v6.759c0,.08,0,.135-.049.16a.209.209,0,0,1-.141.049h-.854a.178.178,0,0,1-.141-.049.239.239,0,0,1-.037-.16V109.63a.19.19,0,0,1,.061-.166.233.233,0,0,1,.129-.043h.842a.166.166,0,0,1,.19.209Z",
    transform: "translate(-286.877 -50.376)",
    fill: "#edeff0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13481",
    "data-name": "Path 13481",
    d: "M297.969,109.407h.842v-1.284a1.843,1.843,0,0,1,.19-.916,1.285,1.285,0,0,1,.5-.5,1.844,1.844,0,0,1,.719-.221,6.526,6.526,0,0,1,.86-.055,4.344,4.344,0,0,1,.442,0l.32.043a.191.191,0,0,1,.141.068.24.24,0,0,1,.037.141v.713a.166.166,0,0,1-.037.117.1.1,0,0,1-.111,0l-.547-.049a3.985,3.985,0,0,0-.442,0,1.161,1.161,0,0,0-.651.141.541.541,0,0,0-.2.479v1.327h1.419a.209.209,0,0,1,.123,0,.286.286,0,0,1,.037.129v.756a.147.147,0,0,1-.037.111.172.172,0,0,1-.123.037h-1.419v5.795a.24.24,0,0,1-.037.16.166.166,0,0,1-.141.049H299a.228.228,0,0,1-.123-.049.172.172,0,0,1-.068-.16v-5.77h-.842a.178.178,0,0,1-.117-.037.129.129,0,0,1-.043-.111v-.756c0-.068,0-.111.043-.129a.221.221,0,0,1,.117-.025Z",
    transform: "translate(-288.627 -50.256)",
    fill: "#edeff0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13482",
    "data-name": "Path 13482",
    d: "M305.884,115.4v-4.3H305.2a.184.184,0,0,1-.123-.037.129.129,0,0,1-.043-.111V110.2c0-.068,0-.111.043-.129a.227.227,0,0,1,.123,0h.75l.326-1.77a.239.239,0,0,1,.074-.172.2.2,0,0,1,.129-.049h.442a.191.191,0,0,1,.148.049.264.264,0,0,1,.049.172v1.77h1.7a.1.1,0,0,1,.147.129v.756a.154.154,0,0,1-.043.111.135.135,0,0,1-.1.037h-1.7v4.351a.615.615,0,0,0,.2.528,1.02,1.02,0,0,0,.658.166h.442l.547-.049a.1.1,0,0,1,.1,0,.166.166,0,0,1,.043.123v.664a.19.19,0,0,1-.172.2,2.218,2.218,0,0,0-.436.043,5.146,5.146,0,0,1-.541.031,5.634,5.634,0,0,1-.817-.055,1.721,1.721,0,0,1-.658-.246,1.192,1.192,0,0,1-.43-.528A2.28,2.28,0,0,1,305.884,115.4Z",
    transform: "translate(-291.411 -50.901)",
    fill: "#edeff0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13483",
    "data-name": "Path 13483",
    d: "M283.023,138.658l2.071-1.506-2.071-1.524a.338.338,0,0,1-.117-.111.369.369,0,0,1-.037-.178v-.664a.209.209,0,0,1,.043-.154c.031-.031.08,0,.154.031l2.722,2.04a.2.2,0,0,1,.074.092.539.539,0,0,1,0,.16v.578a.554.554,0,0,1,0,.16.246.246,0,0,1-.074.092l-2.722,2.052c-.074.055-.123.061-.154.037a.227.227,0,0,1-.043-.16v-.651a.277.277,0,0,1,.043-.166A.474.474,0,0,1,283.023,138.658Z",
    transform: "translate(-282.868 -61.201)",
    fill: "#edeff0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13484",
    "data-name": "Path 13484",
    d: "M296.151,139.909h-2.489a.134.134,0,0,1-.154-.16v-6.833a.166.166,0,0,1,.037-.123.16.16,0,0,1,.117,0h2.489a1.567,1.567,0,0,1,.842.2,1.432,1.432,0,0,1,.541.676,6.318,6.318,0,0,1,.436,1.327,6.844,6.844,0,0,1,.129,1.358,7.058,7.058,0,0,1-.129,1.37,6.267,6.267,0,0,1-.436,1.321,1.462,1.462,0,0,1-.541.676A1.512,1.512,0,0,1,296.151,139.909Zm-1.7-.8h1.678a.541.541,0,0,0,.479-.2,4.374,4.374,0,0,0,.332-.946,6.52,6.52,0,0,0,.166-.823,6.154,6.154,0,0,0,.055-.8,6.6,6.6,0,0,0-.055-.823,5.256,5.256,0,0,0-.166-.811,4.5,4.5,0,0,0-.338-.934.528.528,0,0,0-.473-.2h-1.7Z",
    transform: "translate(-286.969 -60.532)",
    fill: "#edeff0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13485",
    "data-name": "Path 13485",
    d: "M304.74,140.3a1.272,1.272,0,0,0,.737-.16,1.1,1.1,0,0,0,.332-.571.221.221,0,0,1,.08-.135.19.19,0,0,1,.135,0l.473.074a.172.172,0,0,1,.129.08.228.228,0,0,1,0,.141,2.778,2.778,0,0,1-.178.51,1.155,1.155,0,0,1-.332.424,1.665,1.665,0,0,1-.571.295,3.141,3.141,0,0,1-.909.111,3.687,3.687,0,0,1-1.032-.123,1.149,1.149,0,0,1-.614-.442,2.168,2.168,0,0,1-.313-.866,8.7,8.7,0,0,1-.086-1.389,6.836,6.836,0,0,1,.111-1.352,1.979,1.979,0,0,1,.35-.842,1.272,1.272,0,0,1,.615-.424,3.582,3.582,0,0,1,.959-.117,2.758,2.758,0,0,1,.989.154,1.284,1.284,0,0,1,.615.449,1.757,1.757,0,0,1,.283.75,6.7,6.7,0,0,1,.074,1.063v.344a.209.209,0,0,1-.049.154.264.264,0,0,1-.147.037h-2.925a6.265,6.265,0,0,0,.055.922,1.394,1.394,0,0,0,.172.565.615.615,0,0,0,.375.277A2.379,2.379,0,0,0,304.74,140.3Zm-.2-4.05a.946.946,0,0,0-.817.289,2.181,2.181,0,0,0-.233,1.125H305.7a1.776,1.776,0,0,0-.264-1.131A1.155,1.155,0,0,0,304.537,136.247Z",
    transform: "translate(-290.47 -61.591)",
    fill: "#edeff0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13486",
    "data-name": "Path 13486",
    d: "M312.873,136.236a1.684,1.684,0,0,0-.615.08.614.614,0,0,0-.326.3,1.684,1.684,0,0,0-.148.614c0,.258-.031.578-.031.971a9.156,9.156,0,0,0,.037,1.063,1.634,1.634,0,0,0,.166.614.688.688,0,0,0,.375.307,2.218,2.218,0,0,0,.67.086,1.29,1.29,0,0,0,.744-.16,1.1,1.1,0,0,0,.332-.571.2.2,0,0,1,.08-.135.184.184,0,0,1,.129,0l.479.074a.16.16,0,0,1,.123.08.228.228,0,0,1,0,.141,2.771,2.771,0,0,1-.178.51,1.155,1.155,0,0,1-.332.424,1.648,1.648,0,0,1-.578.295,3.073,3.073,0,0,1-.9.111,3.724,3.724,0,0,1-1.039-.123,1.137,1.137,0,0,1-.615-.442,2,2,0,0,1-.313-.866,8.607,8.607,0,0,1-.092-1.389,6.832,6.832,0,0,1,.111-1.352,1.906,1.906,0,0,1,.356-.842,1.229,1.229,0,0,1,.615-.424,3.631,3.631,0,0,1,.965-.117,2.538,2.538,0,0,1,1.395.3,1.512,1.512,0,0,1,.559,1.026.209.209,0,0,1,0,.166.166.166,0,0,1-.135.055l-.485.068a.184.184,0,0,1-.141-.037.308.308,0,0,1-.08-.117.983.983,0,0,0-.313-.535,1.426,1.426,0,0,0-.811-.178Z",
    transform: "translate(-293.65 -61.58)",
    fill: "#edeff0"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13487",
    "data-name": "Path 13487",
    d: "M322.515,139.539l-1.7-2H320.2v2a.154.154,0,0,1-.037.123.123.123,0,0,1-.092.037h-.645a.148.148,0,0,1-.111-.037.184.184,0,0,1-.031-.123v-7.165a.2.2,0,0,1,.031-.129.184.184,0,0,1,.111,0h.615a.178.178,0,0,1,.1,0c.031,0,.043.061.043.129v4.3h.553l1.383-2.224a.485.485,0,0,1,.092-.117.148.148,0,0,1,.111-.037h.694a.148.148,0,0,1,.117.049v.129l-1.567,2.532,2.12,2.55a.074.074,0,0,1,0,.1.111.111,0,0,1-.092.055h-.86a.16.16,0,0,1-.111,0A.861.861,0,0,1,322.515,139.539Z",
    transform: "translate(-296.908 -60.32)",
    fill: "#edeff0"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13488",
    "data-name": "Path 13488",
    d: "M283.023,160.266l2.071-1.505-2.071-1.524a.338.338,0,0,1-.117-.111.368.368,0,0,1-.037-.178v-.664a.209.209,0,0,1,.043-.154.361.361,0,0,1,.154.031l2.722,2.04a.2.2,0,0,1,.074.092.539.539,0,0,1,0,.16v.578a.554.554,0,0,1,0,.16.247.247,0,0,1-.074.092l-2.722,2.034c-.074.055-.123.068-.154.037a.227.227,0,0,1-.043-.16v-.651a.277.277,0,0,1,.043-.166A.474.474,0,0,1,283.023,160.266Z",
    transform: "translate(-282.868 -69.632)",
    fill: "#edeff0"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13489",
    "data-name": "Path 13489",
    d: "M295.336,161.488a5.619,5.619,0,0,1-.977-.068,1.61,1.61,0,0,1-.67-.264,1.192,1.192,0,0,1-.418-.522,2.956,2.956,0,0,1-.221-.866.215.215,0,0,1,0-.16.117.117,0,0,1,.1-.061l.615-.068a.2.2,0,0,1,.135,0,.166.166,0,0,1,.061.117,4.137,4.137,0,0,0,.16.547.7.7,0,0,0,.221.326.829.829,0,0,0,.387.154,4.829,4.829,0,0,0,.67.037,1.512,1.512,0,0,0,1.008-.24,1.192,1.192,0,0,0,.258-.9.8.8,0,0,0-.246-.658,3.545,3.545,0,0,0-.817-.406l-.952-.375a5.16,5.16,0,0,1-.658-.3,1.653,1.653,0,0,1-.461-.363,1.443,1.443,0,0,1-.264-.522,2.812,2.812,0,0,1-.086-.787,1.843,1.843,0,0,1,.541-1.45,2.391,2.391,0,0,1,1.622-.485,2.606,2.606,0,0,1,1.524.356,1.807,1.807,0,0,1,.615,1.327.233.233,0,0,1,0,.154.129.129,0,0,1-.1.068l-.614.068a.16.16,0,0,1-.117-.031.2.2,0,0,1-.061-.1,1.591,1.591,0,0,0-.35-.836,1.456,1.456,0,0,0-.94-.215,1.229,1.229,0,0,0-.946.27,1.4,1.4,0,0,0-.215.879.94.94,0,0,0,.19.651,2.181,2.181,0,0,0,.725.412l.909.363a9.429,9.429,0,0,1,.86.393,1.763,1.763,0,0,1,.51.393,1.26,1.26,0,0,1,.246.5,3.257,3.257,0,0,1,.061.7,1.782,1.782,0,0,1-.578,1.463A2.673,2.673,0,0,1,295.336,161.488Z",
    transform: "translate(-286.787 -68.873)",
    fill: "#edeff0"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13490",
    "data-name": "Path 13490",
    d: "M304.7,156.584a2.243,2.243,0,0,0-.387.031.983.983,0,0,0-.289.117,1.193,1.193,0,0,0-.264.246c-.086.1-.19.24-.307.4v3.761c0,.061,0,.1-.043.123a.123.123,0,0,1-.092.037h-.615a.135.135,0,0,1-.111-.037.153.153,0,0,1-.037-.123v-7.165q0-.1.037-.129a.16.16,0,0,1,.111,0h.614a.2.2,0,0,1,.1,0,.16.16,0,0,1,.043.129v2.587a1.843,1.843,0,0,1,.615-.578,1.745,1.745,0,0,1,.83-.16,1.917,1.917,0,0,1,1.229.338,1.561,1.561,0,0,1,.418,1.266v3.687a.154.154,0,0,1-.043.123.147.147,0,0,1-.1.037H305.8a.135.135,0,0,1-.111-.037.154.154,0,0,1-.037-.123V157.5a1.15,1.15,0,0,0-.166-.7A1.018,1.018,0,0,0,304.7,156.584Z",
    transform: "translate(-290.458 -68.743)",
    fill: "#edeff0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13491",
    "data-name": "Path 13491",
    d: "M315.121,162.394l-.657.166a.154.154,0,0,1-.117,0,.313.313,0,0,1-.1-.135l-.068-.221a1.313,1.313,0,0,1-.061-.295,1.788,1.788,0,0,1-.645.51,1.911,1.911,0,0,1-.83.172,1.991,1.991,0,0,1-1.229-.326,1.456,1.456,0,0,1-.418-1.229,1.844,1.844,0,0,1,.393-1.229,1.7,1.7,0,0,1,1.352-.473h1.327v-.5a1.511,1.511,0,0,0-.166-.811c-.111-.16-.369-.24-.768-.24a3.691,3.691,0,0,0-.5,0,.725.725,0,0,0-.295.1.51.51,0,0,0-.166.234,3.4,3.4,0,0,0-.111.412.154.154,0,0,1-.068.1.147.147,0,0,1-.123,0l-.528-.061a.135.135,0,0,1-.1-.061.2.2,0,0,1,0-.16,1.573,1.573,0,0,1,.553-1.069,2.519,2.519,0,0,1,1.438-.307,1.88,1.88,0,0,1,1.377.412,1.918,1.918,0,0,1,.393,1.34v2.292a3.975,3.975,0,0,0,.031.492,3.8,3.8,0,0,0,.147.553.508.508,0,0,1,0,.178.111.111,0,0,1-.061.154Zm-2.3-.614a1.413,1.413,0,0,0,.615-.147,2.581,2.581,0,0,0,.615-.473v-1.1h-1.321c-.375,0-.615.092-.713.27a1.4,1.4,0,0,0-.147.682.8.8,0,0,0,.19.614,1.069,1.069,0,0,0,.78.178Z",
    transform: "translate(-293.705 -69.959)",
    fill: "#edeff0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13492",
    "data-name": "Path 13492",
    d: "M319.249,155.951h.615v-.959A1.449,1.449,0,0,1,320,154.3a1.013,1.013,0,0,1,.375-.381,1.5,1.5,0,0,1,.547-.166,5.343,5.343,0,0,1,.615-.037h.332l.246.037a.154.154,0,0,1,.1.049.177.177,0,0,1,0,.1v.51a.123.123,0,0,1,0,.086.086.086,0,0,1-.086,0l-.406-.037H321.4a.922.922,0,0,0-.5.1.406.406,0,0,0-.147.356v1h1.063a.166.166,0,0,1,.092,0,.123.123,0,0,1,.031.1v.565a.123.123,0,0,1-.031.086.129.129,0,0,1-.092,0H320.8v4.344a.19.19,0,0,1,0,.123.129.129,0,0,1-.1.037h-.615a.147.147,0,0,1-.092-.037c-.037,0-.049-.061-.049-.123v-4.344h-.615a.123.123,0,0,1-.086,0,.1.1,0,0,1-.037-.086v-.565c0-.049,0-.086.037-.1a.164.164,0,0,1,.012.025Z",
    transform: "translate(-296.874 -68.698)",
    fill: "#edeff0"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13493",
    "data-name": "Path 13493",
    d: "M325.145,160.479v-3.232h-.522a.123.123,0,0,1-.086,0,.1.1,0,0,1-.037-.086V156.6c0-.049,0-.086.037-.1a.16.16,0,0,1,.086,0h.565l.24-1.327a.209.209,0,0,1,.055-.123.166.166,0,0,1,.1-.037h.332a.147.147,0,0,1,.111.037.209.209,0,0,1,.031.123V156.5h1.272a.135.135,0,0,1,.08,0,.123.123,0,0,1,.031.1v.565a.123.123,0,0,1-.031.086.1.1,0,0,1-.08,0h-1.3v3.288a.492.492,0,0,0,.147.4.787.787,0,0,0,.492.123h.332l.412-.037a.08.08,0,0,1,.08,0,.154.154,0,0,1,.031.092v.5a.178.178,0,0,1-.031.1.166.166,0,0,1-.1.049h-.326a3.857,3.857,0,0,1-.4,0,4.664,4.664,0,0,1-.615-.043,1.229,1.229,0,0,1-.492-.184.934.934,0,0,1-.332-.4A1.787,1.787,0,0,1,325.145,160.479Z",
    transform: "translate(-298.917 -69.199)",
    fill: "#edeff0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13494",
    "data-name": "Path 13494",
    d: "M318.576,24.721a7.239,7.239,0,0,1-1.309-.1,2.163,2.163,0,0,1-.891-.344,1.69,1.69,0,0,1-.565-.682,3.8,3.8,0,0,1-.295-1.161.283.283,0,0,1,.037-.209.154.154,0,0,1,.135-.086l.83-.086a.221.221,0,0,1,.178.037.209.209,0,0,1,.086.154,4.806,4.806,0,0,0,.209.731.965.965,0,0,0,.295.43,1.069,1.069,0,0,0,.522.2,5.654,5.654,0,0,0,.891.055,2.028,2.028,0,0,0,1.34-.32,1.629,1.629,0,0,0,.344-1.229,1.032,1.032,0,0,0-.326-.866,4.658,4.658,0,0,0-1.094-.547l-1.266-.5a7.035,7.035,0,0,1-.879-.393,2.052,2.052,0,0,1-.615-.492,1.843,1.843,0,0,1-.356-.688,3.878,3.878,0,0,1-.117-1.051,2.458,2.458,0,0,1,.719-1.93,3.146,3.146,0,0,1,2.181-.651,3.5,3.5,0,0,1,2.028.473,2.409,2.409,0,0,1,.805,1.77.313.313,0,0,1-.031.209.191.191,0,0,1-.135.086l-.8.086a.184.184,0,0,1-.16-.037.221.221,0,0,1-.08-.135,2.12,2.12,0,0,0-.473-1.118,1.923,1.923,0,0,0-1.229-.283,1.61,1.61,0,0,0-1.26.356A1.911,1.911,0,0,0,317,17.575a1.229,1.229,0,0,0,.258.866,2.962,2.962,0,0,0,.965.553l1.229.485A10.4,10.4,0,0,1,320.61,20a2.385,2.385,0,0,1,.676.522,1.677,1.677,0,0,1,.326.664,4.45,4.45,0,0,1,.086.928,2.384,2.384,0,0,1-.774,1.954,3.527,3.527,0,0,1-2.347.651Z",
    transform: "translate(-295.451 -14.588)",
    fill: "#edeff0"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13495",
    "data-name": "Path 13495",
    d: "M331.037,18.146a2.5,2.5,0,0,0-.516.043,1.229,1.229,0,0,0-.381.154,1.7,1.7,0,0,0-.356.326c-.117.141-.252.326-.412.541v5.014a.166.166,0,0,1-.178.2h-.854a.2.2,0,0,1-.147-.043.246.246,0,0,1-.043-.16V14.668a.252.252,0,0,1,.043-.172.233.233,0,0,1,.147-.037h.842a.264.264,0,0,1,.135.037c.037,0,.055.08.055.172v3.447a2.519,2.519,0,0,1,.83-.774,2.4,2.4,0,0,1,1.106-.215,2.581,2.581,0,0,1,1.659.455,2.077,2.077,0,0,1,.553,1.684v4.959a.174.174,0,0,1-.19.2h-.842a.184.184,0,0,1-.147-.043.215.215,0,0,1-.049-.16V19.369a1.548,1.548,0,0,0-.215-.934C331.928,18.245,331.578,18.146,331.037,18.146Z",
    transform: "translate(-300.323 -14.386)",
    fill: "#edeff0"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13496",
    "data-name": "Path 13496",
    d: "M344.935,25.989l-.866.221a.234.234,0,0,1-.16,0,.387.387,0,0,1-.135-.178l-.1-.3c-.031-.117-.055-.246-.08-.393a2.335,2.335,0,0,1-.854.676,2.519,2.519,0,0,1-1.106.24,2.691,2.691,0,0,1-1.665-.436,1.96,1.96,0,0,1-.559-1.628,2.458,2.458,0,0,1,.528-1.647,2.249,2.249,0,0,1,1.8-.615h1.8v-.614a1.967,1.967,0,0,0-.221-1.075c-.147-.215-.492-.326-1.02-.326a4.732,4.732,0,0,0-.664.037.952.952,0,0,0-.4.141.615.615,0,0,0-.221.307,4.723,4.723,0,0,0-.147.547.191.191,0,0,1-.086.141.246.246,0,0,1-.16.037l-.713-.092a.135.135,0,0,1-.123-.08.27.27,0,0,1,0-.215,2.132,2.132,0,0,1,.737-1.419,3.392,3.392,0,0,1,1.917-.406,2.458,2.458,0,0,1,1.843.547,2.513,2.513,0,0,1,.522,1.782v3.072a4.3,4.3,0,0,0,.049.664,4.082,4.082,0,0,0,.19.737.565.565,0,0,1,0,.233.129.129,0,0,1-.111.043Zm-3.072-.78a1.911,1.911,0,0,0,.848-.2,3.588,3.588,0,0,0,.817-.615V22.88H341.77c-.5,0-.817.123-.952.363a1.892,1.892,0,0,0-.2.9,1.1,1.1,0,0,0,.252.83,1.506,1.506,0,0,0,1,.234Z",
    transform: "translate(-304.659 -16.096)",
    fill: "#edeff0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13497",
    "data-name": "Path 13497",
    d: "M350.389,17.32h.842V16.036a1.93,1.93,0,0,1,.19-.916,1.3,1.3,0,0,1,.5-.51,2.138,2.138,0,0,1,.725-.221,7.609,7.609,0,0,1,.854-.049,4.124,4.124,0,0,1,.442.031l.326.043a.191.191,0,0,1,.135.068.227.227,0,0,1,.037.141V15.3a.178.178,0,0,1-.037.117.1.1,0,0,1-.111.031l-.541-.049a4.147,4.147,0,0,0-.442,0,1.174,1.174,0,0,0-.658.141.541.541,0,0,0-.2.479v1.327h1.419a.172.172,0,0,1,.123,0,.285.285,0,0,1,.037.129v.756a.147.147,0,0,1-.037.111.172.172,0,0,1-.123.037h-1.419v5.795a.252.252,0,0,1-.037.16.16.16,0,0,1-.135.043h-.86a.215.215,0,0,1-.123-.043.178.178,0,0,1-.068-.16V18.383h-.842a.178.178,0,0,1-.117-.037.129.129,0,0,1-.043-.111V17.48c0-.068,0-.111.043-.129A.178.178,0,0,1,350.389,17.32Z",
    transform: "translate(-308.836 -14.34)",
    fill: "#edeff0"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13498",
    "data-name": "Path 13498",
    d: "M358.309,23.324v-4.3h-.694a.166.166,0,0,1-.117-.037.135.135,0,0,1-.049-.111V18.12a.141.141,0,0,1,.049-.129.166.166,0,0,1,.117,0h.75l.326-1.77a.3.3,0,0,1,.074-.172A.215.215,0,0,1,358.9,16h.442a.2.2,0,0,1,.148.049.308.308,0,0,1,.043.172v1.77h1.7a.148.148,0,0,1,.111,0,.286.286,0,0,1,.037.129v.756a.129.129,0,0,1-.147.147h-1.7v4.351a.658.658,0,0,0,.2.528,1.032,1.032,0,0,0,.658.16h.442l.547-.055a.111.111,0,0,1,.1.031.178.178,0,0,1,.043.117v.664a.227.227,0,0,1-.043.141.221.221,0,0,1-.135.068,2.254,2.254,0,0,0-.436.043,2.553,2.553,0,0,1-.535.031,4.916,4.916,0,0,1-.823-.061,1.592,1.592,0,0,1-.651-.24,1.186,1.186,0,0,1-.436-.535A2.249,2.249,0,0,1,358.309,23.324Z",
    transform: "translate(-311.618 -14.98)",
    fill: "#edeff0"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13499",
    "data-name": "Path 13499",
    d: "M409.86,72.566a3.158,3.158,0,0,0-2.458-1.481,6.274,6.274,0,0,0-3.9.713c-7.681-4.08-13.242-7.884-16.782-13.021-3.816-5.53-5.377-12.511-5.377-24.113V24.107a2.507,2.507,0,1,0-.307,0V34.664c0,21.176,5.358,28.341,22.165,37.318a3.214,3.214,0,0,0-.977,1,1.739,1.739,0,0,0-.111,1.665,3.146,3.146,0,0,0,2.458,1.487,5.977,5.977,0,0,0,.879.061,5.127,5.127,0,0,0,4.3-1.96A1.77,1.77,0,0,0,409.86,72.566Z",
    transform: "translate(-319.804 -16.174)",
    fill: "#e51a92"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13500",
    "data-name": "Path 13500",
    d: "M472.856,395.771h-3.318a.221.221,0,0,1-.154-.043.2.2,0,0,1-.055-.16v-9.1a.209.209,0,0,1,.055-.166.252.252,0,0,1,.154-.043h3.318a2.213,2.213,0,0,1,1.131.264,1.917,1.917,0,0,1,.713.9,8.277,8.277,0,0,1,.571,1.745,10.022,10.022,0,0,1,0,3.632,7.908,7.908,0,0,1-.584,1.764,1.966,1.966,0,0,1-.713.909,2.15,2.15,0,0,1-1.118.295Zm-2.274-1.063h2.231a.682.682,0,0,0,.615-.27,5.038,5.038,0,0,0,.442-1.26,9.7,9.7,0,0,0,.227-1.1,9.27,9.27,0,0,0,.068-1.069,10.044,10.044,0,0,0-.068-1.1,7.61,7.61,0,0,0-.227-1.082,5.413,5.413,0,0,0-.449-1.229.688.688,0,0,0-.615-.258h-2.243Z",
    transform: "translate(-354.749 -159.497)",
    fill: "#edeff0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13501",
    "data-name": "Path 13501",
    d: "M484.286,396.278a1.659,1.659,0,0,0,.989-.215,1.468,1.468,0,0,0,.443-.756.252.252,0,0,1,.1-.178.264.264,0,0,1,.172-.031l.615.1a.209.209,0,0,1,.166.1.258.258,0,0,1,.037.19,3.691,3.691,0,0,1-.234.676,1.579,1.579,0,0,1-.442.571,2.3,2.3,0,0,1-.768.387,4.142,4.142,0,0,1-1.229.147,4.781,4.781,0,0,1-1.376-.16,1.555,1.555,0,0,1-.842-.615,2.661,2.661,0,0,1-.418-1.155,11.806,11.806,0,0,1-.123-1.843,9.222,9.222,0,0,1,.147-1.807,2.65,2.65,0,0,1,.473-1.118,1.671,1.671,0,0,1,.854-.559,4.627,4.627,0,0,1,1.284-.154,3.632,3.632,0,0,1,1.321.2,1.794,1.794,0,0,1,.8.615,2.292,2.292,0,0,1,.381,1,9.506,9.506,0,0,1,.1,1.419v.485a.233.233,0,0,1-.068.2.307.307,0,0,1-.2.055H482.62a8.494,8.494,0,0,0,.068,1.229,2,2,0,0,0,.234.756.866.866,0,0,0,.5.369A3.281,3.281,0,0,0,484.286,396.278Zm-.264-5.4a1.3,1.3,0,0,0-1.094.381,2.925,2.925,0,0,0-.307,1.505h2.95a2.458,2.458,0,0,0-.356-1.512A1.548,1.548,0,0,0,484.021,390.882Z",
    transform: "translate(-359.394 -160.888)",
    fill: "#edeff0"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13502",
    "data-name": "Path 13502",
    d: "M495.171,390.878a2.256,2.256,0,0,0-.787.111.793.793,0,0,0-.436.4,2.2,2.2,0,0,0-.19.793c-.031.338-.043.768-.043,1.29a12.4,12.4,0,0,0,.049,1.426,2.286,2.286,0,0,0,.221.854.86.86,0,0,0,.5.412,2.894,2.894,0,0,0,.891.111,1.659,1.659,0,0,0,.989-.215,1.469,1.469,0,0,0,.442-.756.252.252,0,0,1,.1-.178.283.283,0,0,1,.178-.031l.615.1a.221.221,0,0,1,.172.1.258.258,0,0,1,.037.19,4.178,4.178,0,0,1-.234.676,1.578,1.578,0,0,1-.442.571,2.3,2.3,0,0,1-.768.387,4.14,4.14,0,0,1-1.229.147,4.779,4.779,0,0,1-1.376-.16,1.555,1.555,0,0,1-.842-.615,2.741,2.741,0,0,1-.424-1.155,12.724,12.724,0,0,1-.117-1.844,9.217,9.217,0,0,1,.147-1.807,2.648,2.648,0,0,1,.473-1.118,1.671,1.671,0,0,1,.854-.559,4.594,4.594,0,0,1,1.284-.154,3.349,3.349,0,0,1,1.844.393,2.016,2.016,0,0,1,.756,1.376.313.313,0,0,1-.043.209.209.209,0,0,1-.178.086l-.651.086a.221.221,0,0,1-.19-.049.381.381,0,0,1-.1-.16,1.333,1.333,0,0,0-.418-.713,1.942,1.942,0,0,0-1.081-.215Z",
    transform: "translate(-363.673 -160.884)",
    fill: "#edeff0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13503",
    "data-name": "Path 13503",
    d: "M508.011,395.284l-2.28-2.673h-.8v2.673a.227.227,0,0,1-.049.16.191.191,0,0,1-.129.043H503.9a.2.2,0,0,1-.147-.043.228.228,0,0,1-.043-.16v-9.562c0-.086,0-.141.043-.166a.234.234,0,0,1,.147-.037h.842a.264.264,0,0,1,.135.037q.055.037.055.166v5.77h.737l1.844-2.968a.9.9,0,0,1,.117-.154.252.252,0,0,1,.147-.049h.934a.172.172,0,0,1,.154.068c.031.043,0,.1,0,.166l-2.108,3.318,2.833,3.41a.086.086,0,0,1,0,.129.147.147,0,0,1-.123.074h-1.155a.233.233,0,0,1-.147-.037Z",
    transform: "translate(-368.002 -159.213)",
    fill: "#edeff0"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13504",
    "data-name": "Path 13504",
    d: "M520.022,397.034l-.866.221a.221.221,0,0,1-.166-.031.331.331,0,0,1-.129-.172l-.1-.307a2.038,2.038,0,0,1-.08-.387,2.384,2.384,0,0,1-.854.676,2.556,2.556,0,0,1-1.106.24,2.716,2.716,0,0,1-1.671-.436,1.985,1.985,0,0,1-.559-1.628,2.458,2.458,0,0,1,.535-1.647,2.236,2.236,0,0,1,1.794-.615h1.8v-.615a1.966,1.966,0,0,0-.221-1.075c-.147-.221-.485-.326-1.014-.326a4.739,4.739,0,0,0-.664.037.848.848,0,0,0-.4.141.614.614,0,0,0-.221.307,4.411,4.411,0,0,0-.147.547.221.221,0,0,1-.252.178l-.707-.092a.154.154,0,0,1-.129-.08.3.3,0,0,1,0-.215,2.1,2.1,0,0,1,.737-1.419,3.391,3.391,0,0,1,1.917-.406,2.507,2.507,0,0,1,1.844.541,2.557,2.557,0,0,1,.522,1.788v3.072a4.349,4.349,0,0,0,.043.664,4.683,4.683,0,0,0,.19.737.484.484,0,0,1,0,.233A.135.135,0,0,1,520.022,397.034Zm-3.073-.78a1.844,1.844,0,0,0,.848-.2,3.46,3.46,0,0,0,.817-.615v-1.506h-1.751c-.5,0-.823.117-.952.362a1.844,1.844,0,0,0-.2.9,1.124,1.124,0,0,0,.252.83,1.517,1.517,0,0,0,1,.221Z",
    transform: "translate(-372.154 -160.908)",
    fill: "#edeff0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13505",
    "data-name": "Path 13505",
    d: "M527.76,390.2v.977c.2-.277.381-.5.522-.67a2.244,2.244,0,0,1,.412-.4,1.309,1.309,0,0,1,.424-.19,2.207,2.207,0,0,1,.528-.049,2.111,2.111,0,0,1,.344,0l.276.049a.2.2,0,0,1,.141.061.251.251,0,0,1,.037.141v.78a.159.159,0,0,1-.061.123.252.252,0,0,1-.135.043,3.074,3.074,0,0,0-.406-.068h-.387a1.229,1.229,0,0,0-.369.049.749.749,0,0,0-.313.2,5.259,5.259,0,0,0-.387.455c-.154.2-.363.473-.615.8v4.443a.2.2,0,0,1-.055.16.166.166,0,0,1-.123.043h-.854a.2.2,0,0,1-.148-.043.227.227,0,0,1-.043-.16v-6.759a.228.228,0,0,1,.043-.16.2.2,0,0,1,.148-.043h.842a.19.19,0,0,1,.129.043.184.184,0,0,1,.049.172Z",
    transform: "translate(-376.807 -160.886)",
    fill: "#edeff0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13506",
    "data-name": "Path 13506",
    d: "M537.183,396.278a1.647,1.647,0,0,0,.989-.215,1.468,1.468,0,0,0,.442-.756.252.252,0,0,1,.1-.178.277.277,0,0,1,.178-.031l.614.1a.2.2,0,0,1,.166.1.258.258,0,0,1,.037.19,3.685,3.685,0,0,1-.233.676,1.579,1.579,0,0,1-.442.571,2.3,2.3,0,0,1-.768.387,4.144,4.144,0,0,1-1.229.147,4.782,4.782,0,0,1-1.376-.16,1.579,1.579,0,0,1-.842-.614,2.74,2.74,0,0,1-.418-1.155,11.915,11.915,0,0,1-.117-1.843,9.223,9.223,0,0,1,.148-1.807,2.649,2.649,0,0,1,.467-1.118,1.689,1.689,0,0,1,.86-.559,4.547,4.547,0,0,1,1.278-.154,3.632,3.632,0,0,1,1.321.2,1.763,1.763,0,0,1,.8.615,2.291,2.291,0,0,1,.381,1,8.762,8.762,0,0,1,.1,1.419v.485a.233.233,0,0,1-.068.2.3.3,0,0,1-.2.055h-3.9a9.463,9.463,0,0,0,.068,1.229,2,2,0,0,0,.233.756.892.892,0,0,0,.5.369A3.313,3.313,0,0,0,537.183,396.278Zm-.264-5.4a1.3,1.3,0,0,0-1.094.381,2.925,2.925,0,0,0-.307,1.506h2.95a2.459,2.459,0,0,0-.356-1.512,1.536,1.536,0,0,0-1.2-.375Z",
    transform: "translate(-379.791 -160.888)",
    fill: "#edeff0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13507",
    "data-name": "Path 13507",
    d: "M550.742,397.034l-.866.221a.221.221,0,0,1-.166-.031.332.332,0,0,1-.129-.172l-.1-.307a2.038,2.038,0,0,1-.08-.387,2.385,2.385,0,0,1-.854.676,2.557,2.557,0,0,1-1.106.24,2.716,2.716,0,0,1-1.671-.436,1.985,1.985,0,0,1-.559-1.628,2.458,2.458,0,0,1,.535-1.647,2.237,2.237,0,0,1,1.794-.615h1.8v-.615a1.966,1.966,0,0,0-.221-1.075c-.147-.221-.485-.326-1.014-.326a4.74,4.74,0,0,0-.664.037.849.849,0,0,0-.4.141.615.615,0,0,0-.221.307,4.412,4.412,0,0,0-.148.547.221.221,0,0,1-.252.178l-.707-.092a.154.154,0,0,1-.129-.08.3.3,0,0,1,0-.215,2.1,2.1,0,0,1,.737-1.419,3.391,3.391,0,0,1,1.917-.406,2.507,2.507,0,0,1,1.843.541,2.556,2.556,0,0,1,.522,1.788v3.072a4.357,4.357,0,0,0,.043.664,4.676,4.676,0,0,0,.19.737.486.486,0,0,1,0,.234A.135.135,0,0,1,550.742,397.034Zm-3.073-.78a1.844,1.844,0,0,0,.848-.2,3.459,3.459,0,0,0,.817-.615v-1.506h-1.751c-.5,0-.823.117-.952.362a1.844,1.844,0,0,0-.2.9,1.125,1.125,0,0,0,.252.83,1.517,1.517,0,0,0,1,.221Z",
    transform: "translate(-383.997 -160.908)",
    fill: "#edeff0"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13508",
    "data-name": "Path 13508",
    d: "M343.41,416.531h-3.318a.221.221,0,0,1-.154-.043.19.19,0,0,1-.049-.16v-9.1c0-.08,0-.135.049-.16a.221.221,0,0,1,.154-.049h3.318a2.151,2.151,0,0,1,1.131.27,1.843,1.843,0,0,1,.713.9,7.947,7.947,0,0,1,.584,1.77,9.514,9.514,0,0,1,.166,1.813,9.688,9.688,0,0,1-.166,1.844,7.66,7.66,0,0,1-.584,1.757,1.967,1.967,0,0,1-.713.909A2.1,2.1,0,0,1,343.41,416.531Zm-2.268-1.057h2.237a.688.688,0,0,0,.615-.277,4.919,4.919,0,0,0,.442-1.26,8.5,8.5,0,0,0,.221-1.1,8.1,8.1,0,0,0,.074-1.069,8.845,8.845,0,0,0-.074-1.1,6.865,6.865,0,0,0-.221-1.082,5.416,5.416,0,0,0-.449-1.229.688.688,0,0,0-.614-.258h-2.237Z",
    transform: "translate(-304.849 -167.5)",
    fill: "#edeff0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13509",
    "data-name": "Path 13509",
    d: "M354.839,417.034a1.715,1.715,0,0,0,.989-.209,1.518,1.518,0,0,0,.442-.762.27.27,0,0,1,.1-.178.264.264,0,0,1,.172-.031l.615.1a.209.209,0,0,1,.166.1.265.265,0,0,1,.037.191,3.72,3.72,0,0,1-.234.682,1.56,1.56,0,0,1-.442.565,2.311,2.311,0,0,1-.768.393,4.142,4.142,0,0,1-1.229.147,4.756,4.756,0,0,1-1.376-.166,1.5,1.5,0,0,1-.842-.614,2.661,2.661,0,0,1-.418-1.155,11.823,11.823,0,0,1-.117-1.843,9.219,9.219,0,0,1,.141-1.807,2.643,2.643,0,0,1,.473-1.125,1.671,1.671,0,0,1,.854-.559,4.628,4.628,0,0,1,1.284-.154,3.767,3.767,0,0,1,1.321.2,1.794,1.794,0,0,1,.8.614,2.322,2.322,0,0,1,.381,1.008,9.364,9.364,0,0,1,.1,1.413v.485a.258.258,0,0,1-.068.2.35.35,0,0,1-.2.049H353.2a8.442,8.442,0,0,0,.068,1.229,2,2,0,0,0,.234.756.866.866,0,0,0,.5.369A3.281,3.281,0,0,0,354.839,417.034Zm-.264-5.4a1.3,1.3,0,0,0-1.094.381,2.943,2.943,0,0,0-.307,1.506h2.95a2.458,2.458,0,0,0-.356-1.512A1.549,1.549,0,0,0,354.575,411.639Z",
    transform: "translate(-309.494 -168.888)",
    fill: "#edeff0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13510",
    "data-name": "Path 13510",
    d: "M365.721,411.634a2.256,2.256,0,0,0-.787.111.811.811,0,0,0-.436.4,2.2,2.2,0,0,0-.19.793c-.031.344-.043.774-.043,1.29a12.447,12.447,0,0,0,.049,1.426,2.286,2.286,0,0,0,.221.854.861.861,0,0,0,.5.412,2.9,2.9,0,0,0,.891.111,1.715,1.715,0,0,0,.989-.209,1.518,1.518,0,0,0,.442-.762.264.264,0,0,1,.1-.178.282.282,0,0,1,.178-.031l.614.1a.221.221,0,0,1,.172.1.264.264,0,0,1,.037.19,4.249,4.249,0,0,1-.234.682,1.561,1.561,0,0,1-.442.565,2.312,2.312,0,0,1-.768.393,4.141,4.141,0,0,1-1.229.147,4.754,4.754,0,0,1-1.376-.166,1.5,1.5,0,0,1-.842-.615,2.741,2.741,0,0,1-.424-1.155,12.629,12.629,0,0,1-.117-1.843,9.129,9.129,0,0,1,.147-1.807,2.643,2.643,0,0,1,.473-1.125,1.671,1.671,0,0,1,.854-.559,4.6,4.6,0,0,1,1.284-.154,3.288,3.288,0,0,1,1.844.4,1.991,1.991,0,0,1,.756,1.37.338.338,0,0,1-.043.215.222.222,0,0,1-.178.08l-.651.086a.221.221,0,0,1-.19-.049.362.362,0,0,1-.1-.154,1.327,1.327,0,0,0-.418-.719A1.941,1.941,0,0,0,365.721,411.634Z",
    transform: "translate(-313.77 -168.883)",
    fill: "#edeff0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13511",
    "data-name": "Path 13511",
    d: "M378.576,416.044l-2.255-2.673h-.8v2.673a.215.215,0,0,1-.049.16.191.191,0,0,1-.129.043h-.854a.2.2,0,0,1-.147-.043.215.215,0,0,1-.043-.16v-9.555c0-.092,0-.147.043-.172a.233.233,0,0,1,.147-.037h.854a.264.264,0,0,1,.135.037c.037,0,.055.08.055.172v5.764h.737l1.843-2.962a.766.766,0,0,1,.117-.16.251.251,0,0,1,.154-.049h.928a.19.19,0,0,1,.154.068c.031.043,0,.1,0,.166l-2.108,3.318,2.833,3.41a.086.086,0,0,1,0,.129.147.147,0,0,1-.123.074h-1.155a.234.234,0,0,1-.147-.037Z",
    transform: "translate(-318.114 -167.216)",
    fill: "#edeff0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13512",
    "data-name": "Path 13512",
    d: "M441.688,354.2V339.453c0-20.635-3.54-28-14.533-36.679a2.379,2.379,0,0,0,.836-.922,1.88,1.88,0,0,0-.117-1.813c-.83-1.432-3.177-2.3-5.328-1.973a3.285,3.285,0,0,0-2.6,1.567,1.893,1.893,0,0,0,.111,1.813,5.2,5.2,0,0,0,4.412,2.04,5.818,5.818,0,0,0,.922-.068,4.729,4.729,0,0,0,1.18-.326c11.147,8.707,14.5,15.676,14.5,36.36V354.2a2.667,2.667,0,1,0,.615,0Z",
    transform: "translate(-335.643 -125.473)",
    fill: "#9bcd7d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(0.315 5.444)",
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    y1: 0.436,
    transform: "translate(0 40.704)",
    fill: "none",
    stroke: "#ed5fb3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13513",
    "data-name": "Path 13513",
    d: "M283.38,63.057V50.767c0-9.463,3.208-22.386,13.636-27.007",
    transform: "translate(-283.38 -23.416)",
    fill: "none",
    stroke: "#ed5fb3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71,
    strokeDasharray: "1.44 1.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13514",
    "data-name": "Path 13514",
    d: "M306.36,23.36l.406-.16",
    transform: "translate(-292.239 -23.2)",
    fill: "none",
    stroke: "#ed5fb3",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(1.413 99.647)",
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    y2: 0.436,
    transform: "translate(0.075)",
    fill: "none",
    stroke: "#b2c8db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13515",
    "data-name": "Path 13515",
    d: "M285.243,181.81v54.407c0,66.157-2.943,88.881,27.96,89.329",
    transform: "translate(-285.167 -180.329)",
    fill: "none",
    stroke: "#b2c8db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71,
    strokeDasharray: "1.41 1.69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13516",
    "data-name": "Path 13516",
    d: "M331.63,415.73h.436",
    transform: "translate(-303.079 -270.506)",
    fill: "none",
    stroke: "#b2c8db",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.71
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13517",
    "data-name": "Path 13517",
    d: "M365.423,187.839l-3.964-2.286-1.051-1.653-2.839,1.653,5.911,3.41Z",
    transform: "translate(-311.666 -80.461)",
    fill: "#f4f4f4"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13518",
    "data-name": "Path 13518",
    d: "M477.347,129.264l-4.787,2.778,1.948,1.131,7.835-4-3.392-1.671Z",
    transform: "translate(-355.995 -58.469)",
    fill: "#f4f4f4"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13519",
    "data-name": "Path 13519",
    d: "M369.624,171.027c-.836-1.432-3.183-2.3-5.334-1.973a4.166,4.166,0,0,0-1.844.694c-16.591-8.9-21.563-15.762-21.563-36.728V115.815a2.667,2.667,0,1,0-.615,0v17.206c0,21.022,5.26,28.267,21.7,37.165a2.235,2.235,0,0,0-.289.436,1.893,1.893,0,0,0,.117,1.813h0a5.18,5.18,0,0,0,4.406,2.04,5.894,5.894,0,0,0,.928-.068,3.335,3.335,0,0,0,2.593-1.567A1.893,1.893,0,0,0,369.624,171.027Z",
    transform: "translate(-304.087 -51.973)",
    fill: "#facb66"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M370.853,199.652l-.123-4.584,26.6-15.5,30.626,17.7-.1,57.21-30.522,17.734-24.949-14.4Z",
    transform: "translate(-316.739 -79.18)",
    fill: "none",
    stroke: "#facb66",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13521",
    "data-name": "Path 13521",
    d: "M363.567,270.768l1.327-.768-.147,51.439-1.327.768Z",
    transform: "translate(-313.921 -114.306)",
    fill: "#939598"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13522",
    "data-name": "Path 13522",
    d: "M393.406,285.7l-.148,53.191-1.487-.854.147-51.489-29.281-16.9-.147,51.439-1.481-.854.147-53.148Z",
    transform: "translate(-312.992 -113.554)",
    fill: "#c7c8ca"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13523",
    "data-name": "Path 13523",
    d: "M413.637,296.9l1.327-.768-.154,53.191-1.321.768Z",
    transform: "translate(-333.223 -124.753)",
    fill: "#939598"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13524",
    "data-name": "Path 13524",
    d: "M361.25,266.6l1.327-.768,32.249,18.619-1.327.768Z",
    transform: "translate(-313.084 -112.48)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_13525",
    "data-name": "Path 13525",
    d: "M365.58,322.323l.147-49.823,27.953,16.137v1.131l-27.425-15.854v48.8Z",
    transform: "translate(-314.754 -115.27)",
    fill: "#005e9e",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13526",
    "data-name": "Path 13526",
    d: "M368.656,238.332a3.283,3.283,0,0,0-1.9-2.366,1.893,1.893,0,0,0-1.782.356,4.987,4.987,0,0,0-1.469,4.172c-17.009,9.058-22.423,16.223-22.423,37.552v51.618a2.661,2.661,0,1,0,.615,0V278.046c0-21.1,5.027-27.91,21.876-36.87a7.128,7.128,0,0,0,.16.719,3.275,3.275,0,0,0,1.9,2.366,1.738,1.738,0,0,0,.559.086,1.966,1.966,0,0,0,1.229-.442C368.724,242.867,369.27,240.427,368.656,238.332Z",
    transform: "translate(-304.403 -101.526)",
    fill: "#b2c8db"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7781",
    "data-name": "Group 7781",
    transform: "translate(403.088 -424)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4021",
    "data-name": "Rectangle 4021",
    width: 296,
    height: 262.14,
    transform: "translate(5283.912 6550.43)",
    fill: "none"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGlossaryEquipment);
export default __webpack_public_path__ + "static/media/img-glossary-equipment.0d6666a9.svg";
export { ForwardRef as ReactComponent };